import React from 'react'
import { Modal, Button, Message, Divider, Grid } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { singleLineText } from '../../../../common/RegexValidation';
import { withRouter } from 'react-router-dom';
import { Form } from 'formsy-semantic-ui-react';
import { toastr } from "react-redux-toastr";
class CreateNewWorkspace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addWorkspaceError: null,
            formcyButtonDisabled: false
        }
    }

    close = () => {
        this.setState({ "addWorkspaceError": null })
        this.props.openCreateNewWorkspaceModal(false)
    }

    gotToUpgradePage = () => {
        this.props.openCreateNewWorkspaceModal(false)
        const history = this.props.history;

        history.push({
            pathname: `/app/${this.props.accountId}/upgrade`
        });
    }

    handleWorkspaceName = () => {
        if (this.state.addWorkspaceError !== null) {
            this.setState({ "addWorkspaceError": null })
        }
    }
    createNewWorkspace = async (formData) => {
        try {
            if (this.props.type === "create") {
                await dispatch.app.addNewWorkspace({
                    workspaceName: formData.workspaceName.trim(),
                    user: this.props.user,
                    accountId: this.props.accountId,
                    redirectTo: "account"
                });
                if (this.props.tableFilterQuery) {
                    dispatch.account.getAcountUserWorkspaces(this.props.tableFilterQuery)
                }
            } else if (this.props.type === "edit") {
                await dispatch.organizationUnit.updateWorkspace({
                    organizationId: this.props.data.id,
                    accountUserId: this.props.user._id,
                    accountId: this.props.accountId,
                    data: {
                        name: formData.workspaceName.trim(),
                        slug: formData.workspaceName.toLowerCase().trim(),
                        oldName: this.props.data.name
                    }
                });
            }

            await this.props.openCreateNewWorkspaceModal(false)
            toastr.success("Message", "Workspace created successfully.");
        }
        catch (err) {
            this.setState({ "addWorkspaceError": err })
        }
    }

    buttonDisabled = (e, set) => {
        this.setState({ formcyButtonDisabled: set });
    }


    render() {

        const errorLabel = <div className="customErrorLabel" />;
        const { accountSubscriptionDetail, open, type, data } = this.props

        let subCount = accountSubscriptionDetail && accountSubscriptionDetail.createWorkspace && accountSubscriptionDetail.createWorkspace.entityCount
        let subLimit = accountSubscriptionDetail && accountSubscriptionDetail.createWorkspace && accountSubscriptionDetail.createWorkspace.allowedLimit

        let count = subCount !== 0 ? subCount : 0;
        let limit = subLimit !== 0 ? subLimit : 0;
        let createWorkspaceValidation = limit !== -1 && count >= limit && type === "create";



        // cancel button----------------------------------------------------
        let canceldButton = <React.Fragment>
            <Button content='Cancel' className="button-cancel" onClick={this.close} type="button" />
        </React.Fragment>
        // Upgrade button ---------------------------------------------------
        let upgradButton = <React.Fragment>
            <Button content='Upgrade' className="button-submit" onClick={this.gotToUpgradePage} type="submit" />
        </React.Fragment>

        // actions button---------------------------------------------------
        let wu = <div className="float-left text-left" >
            <div className="float-left">
                Workspaces <br />Utilization
            </div> &nbsp;&nbsp;

            <div className="float-left" style={{ margin: "0 0 0 10px" }}>
                <span className="f_24">{count}</span> / {limit}
            </div>
        </div>

        let actions = <React.Fragment>
            {limit !== -1 ? wu : null}
            {type === "create" ?
                <Button disabled={!this.state.formcyButtonDisabled} content='Create' className="button-submit float-right" />
                :
                <Button disabled={!this.state.formcyButtonDisabled} content='Update' className="button-submit float-right" />
            }
            <Button content="Cancel" className="button-cancel" onClick={this.close} type="button" />
        </React.Fragment>

        // Subscription End Error Message-----------------------------------------------------
        let subErrorMessage = <Message error >
            <Message.Header>Workspace creation limit reached!</Message.Header>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={12} className="pad_0">
                        <p>
                            You have reached your workspace creation limit for this account. <br />
                            You can increase your limit by upgrading your subscription.
                        </p>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        {wu}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Message>



        return (
            <Modal
                className="basicModal close"
                open={open}
                size={createWorkspaceValidation ? "small" : "mini"}
                id="newWorkspaceForm"
                onClose={this.close}
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                {createWorkspaceValidation ?
                    <React.Fragment>
                        <Modal.Header>Upgrade Subscription</Modal.Header>
                        <Divider />
                        <Modal.Content className="pad_20">
                            {subErrorMessage}
                        </Modal.Content>
                        <Modal.Actions className="actionInFormcy">
                            {canceldButton}
                            {upgradButton}
                        </Modal.Actions>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <Modal.Header>
                            {type === "create" ? "Create Workspace" : `Rename Workspace`}
                        </Modal.Header>


                        <Form noValidate
                            error
                            className=""
                            ref={ref => this.form = ref}
                            onValidSubmit={this.createNewWorkspace}
                            onValid={(e) => this.buttonDisabled(e, true)}
                            onInvalid={(e) => this.buttonDisabled(e, false)}
                            id="createWorkspace">
                            <Modal.Content className="pad_20">

                                <Form.Input
                                    required
                                    name="workspaceName"
                                    id="workspaceName"
                                    label="Workspace Name"
                                    errorLabel={errorLabel}
                                    value={data ? data.name : ""}
                                    onChange={this.handleWorkspaceName}
                                    validations={{ matchRegexp: singleLineText }}
                                    validationErrors={{
                                        noSpaces: 'Workspace name should not be empty.',
                                        matchRegexp: 'Workspace name should not be empty. Max limit is 128.',
                                        isDefaultRequiredValue: 'Workspace Name is required.',
                                    }}
                                    instantValidation
                                    autoFocus
                                />

                                {this.state.addWorkspaceError && this.state.addWorkspaceError.code === 409 ?
                                    <span className="clr-red">Workspace with same name already exists.</span>
                                    : this.state.addWorkspaceError && this.state.addWorkspaceError.message ?
                                        <Message
                                            error
                                            content={this.state.addWorkspaceError.message}
                                        /> : ''}
                            </Modal.Content>
                            <Modal.Actions className="actionInFormcy">
                                {actions}
                            </Modal.Actions>
                        </Form>
                    </React.Fragment>
                }

            </Modal>
        )
    }
}

export default withRouter(CreateNewWorkspace);